var path = 'public/app/features/plugins/partials/plugin_page.html';
var html = "<navbar model=ctrl.navModel ng-if=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div ng-if=ctrl.page>\n\t\t<plugin-component type=app-page>\n\t\t</plugin-component>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/plugins/partials/plugin_page.html
// module id = 609
// module chunks = 5